import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "16",
  viewBox: "0 0 18 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      id: "vector",
      d: "M11.2306 4.15105C10.405 2.36458 8.59732 1.125 6.50008 1.125C3.6236 1.125 1.29175 3.45685 1.29175 6.33333C1.29175 9.16345 3.54902 11.4663 6.36141 11.5399M16.7084 9.66667C16.7084 12.5431 14.3766 14.875 11.5001 14.875C9.2839 14.875 7.39101 13.4908 6.63875 11.5399C6.41462 10.9586 6.29175 10.327 6.29175 9.66667C6.29175 6.83655 8.54903 4.53365 11.3614 4.46014C11.4075 4.45894 11.4537 4.45833 11.5001 4.45833C14.3766 4.45833 16.7084 6.79018 16.7084 9.66667Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "square"
    }, null, -1)
  ])))
}
export default { render: render }